// Páginas delgadas para los módulos CRUD genéricos. Reutilizan ListView/RecordView
// leyendo la definición del módulo del registro.
import type { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { MODULES } from "../modules/registry.tsx";
import { ListView } from "../components/ListView.tsx";
import { RecordView } from "../components/RecordView.tsx";
import { AccountBilling, AccountContacts, AccountRut, AccountTeam, ContactAccount, ContactEmails } from "../components/Related.tsx";
import { ViewPortfolioButton } from "../components/PortfolioButton.tsx";
import { Button } from "../components/ui.tsx";
import type { Row } from "../lib/resource.ts";
import { ContactMarketingTimeline } from "./marketing/contacts/ContactMarketingTimeline.tsx";

export function ModuleList({ moduleKey }: { moduleKey: string }): JSX.Element {
  const navigate = useNavigate();
  const mod = MODULES[moduleKey];
  if (!mod) return <div>Módulo desconocido.</div>;
  const extra: JSX.Element | ((f: Record<string, string>) => JSX.Element) | undefined = moduleKey === "leads"
    ? <Button onClick={() => navigate("/leads/kanban")}>Kanban</Button>
    : moduleKey === "products"
      ? (f: Record<string, string>) => <ViewPortfolioButton businessUnitId={f["businessUnitId"]} />
      : undefined;
  return <ListView mod={mod} {...(extra ? { extraActions: extra } : {})} />;
}

export function ModuleRecord({ moduleKey }: { moduleKey: string }): JSX.Element {
  const navigate = useNavigate();
  const mod = MODULES[moduleKey];
  if (!mod) return <div>Módulo desconocido.</div>;

  const headerExtra = moduleKey === "leads"
    ? (row: Row): JSX.Element | null =>
        row["isConverted"]
          ? null
          : <Button variant="primary" onClick={() => navigate(`/leads/${String(row["id"])}/convert`)}>Convertir</Button>
    : undefined;

  // Relacionados: contactos dentro de la cuenta, y la cuenta dentro del contacto.
  const children = moduleKey === "accounts"
    ? (row: Row): JSX.Element => (
        <>
          <AccountTeam accountId={String(row["id"])} />
          <AccountContacts accountId={String(row["id"])} />
        </>
      )
    : moduleKey === "contacts"
      ? (row: Row): JSX.Element => (
          <>
            <ContactAccount contact={row} />
            <ContactEmails contactId={String(row["id"])} />
            <ContactMarketingTimeline contactId={String(row["id"])} />
          </>
        )
      : undefined;

  // Zona lateral (bajo "Sistema"): RUT y facturación electrónica, visibles sin scroll.
  const aside = moduleKey === "accounts"
    ? (row: Row): JSX.Element => (
        <>
          <AccountRut accountId={String(row["id"])} />
          <AccountBilling accountId={String(row["id"])} />
        </>
      )
    : undefined;

  return <RecordView mod={mod} {...(headerExtra ? { headerExtra } : {})} {...(children ? { children } : {})} {...(aside ? { aside } : {})} />;
}
